import React from 'react';
import clsx from 'clsx';

import type { WorkspaceSyncStatus as SyncStatus } from './useUnsavedEditsGuard';

import styles from './WorkspaceSyncStatus.module.scss';

const LABELS: Record<Exclude<SyncStatus, 'idle'>, string> = {
    unsaved: 'Unsaved changes',
    saved: 'Added to Workspace',
};

/**
 * Header pill for the editable file drawers in a view context: tells the user
 * whether what they see has reached Workspace. Renders nothing while idle
 * (untouched file, nothing added yet) — the same "only light up when it
 * matters" rule as SheetEditorDrawer's autosave indicator.
 */
const WorkspaceSyncStatus: React.FC<{ status: SyncStatus }> = ({ status }) => {
    if (status === 'idle') return null;
    return (
        <div
            className={clsx(styles.WorkspaceSyncStatus, status === 'unsaved' ? styles.Unsaved : styles.Saved)}
            aria-live="polite"
            data-testid="workspace-sync-status"
        >
            <span className={styles.Dot} aria-hidden />
            <span>{LABELS[status]}</span>
        </div>
    );
};

export default WorkspaceSyncStatus;
